<div class="terms-confirm-popup">
    <owc-modal-dialog #owcConfigModelDialog [visible]="true"  disable-backdrop-click [size]="'large'">
        <owc-component-header class="modal-header">
           {{i18n.TERMS_CONDITIONS.HEADER}}
        </owc-component-header>
         <div class="modal-content" class="padd-16">
           
            <owc-typography [variant]="'body2'" class="padd-t-8 content">                
                {{infoContent}}
            </owc-typography>
        </div>
        <owc-component-footer slot="footer" class="modal-footer-cls bottom-border">
            <owc-button data-testid="terms-page-decline-btn" (click)="onDecline()"  [variant]="'secondary'" class="footer-btn-align">
                {{i18n.TERMS_CONDITIONS.DECLINE}}</owc-button>
            <owc-button data-testid="terms-page-accept-btn" class="margin-left-16" (click)="onAccept()">
                {{i18n.TERMS_CONDITIONS.ACCEPT}}</owc-button>
        </owc-component-footer>
    </owc-modal-dialog>
</div>

